import React, { useState } from 'react'
import { IconLogo } from '../../constants/icons'
import { COMPANY_NAME, HOT_LINE } from '../../constants/common'
import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons/lib'
import moment from 'moment'
import { Button, Input, message, Form } from 'antd'
import { useLocation } from 'react-router'
import { ValidationForm } from '../../constants/interface'
import { isEmailValid } from '../../func/common'
import { addSubscriber } from '../../api/common-api'

const Footer = () => {
    const { pathname } = useLocation()
    const [email, setEmail] = useState<string>('')
    const [validateEmail, setValidateEmail] = useState<ValidationForm>({ status: 'success', text: '' })
    const clearValidate = () => {
        setValidateEmail({ status: 'success', text: '' })
    }
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const handleChangeEmail = (value: string) => {
        setEmail(value)
        clearValidate()
    }
    const handleSubmit = async () => {
        if (!email) {
            setValidateEmail({ status: 'error', text: 'Vui lòng nhập email' })
            return
        }
        if (email && !isEmailValid(email)) {
            setValidateEmail({ status: 'error', text: 'Email không đúng định dạng' })
            return
        }

        try {
            setIsLoading(true)
            const data = {
                email: email,
                type: 'subscriber',
            }
            const res = await addSubscriber(data)
            setIsLoading(false)
            if (res.status === 'success') {
                setEmail('')
                message.success('Bạn đăng ký nhận thông báo thành công')
            } else {
                if(res.data.error_code) {
                    message.error(' Địa chỉ email đã tồn tại')
                } else {
                    message.error('Đăng ký không thành công')
                }
            }
        } catch (e) {
            throw e
        }
    }
    return (
        <div
            className={`footer ${['/'].includes(pathname) ? 'footer__pad0' : ''} ${
                pathname.startsWith('/combo-detail') ? 'footer__pad0' : ''
            }`}
        >
            <div className="footer__top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-sm-5">
                            <div className="footer__vnt__info">
                                <IconLogo />
                                <p className="semibold company__name">{COMPANY_NAME}</p>
                                <p>
                                    <EnvironmentOutlined />
                                    <span>
                                        Số 10/55 Thụy Khuê, Phường Thuỵ Khuê, Quận Tây Hồ, Thành phố Hà Nội, Việt Nam
                                    </span>
                                </p>
                                <p>
                                    <a style={{ margin: 0 }} href="mailto:cs@vntrip.vn">
                                        <MailOutlined />
                                        <span>cs@vntrip.vn</span>
                                    </a>
                                </p>
                                <p>
                                    <a style={{ margin: 0 }} href={`tel:${HOT_LINE}`}>
                                        <PhoneOutlined />
                                        <span> {HOT_LINE}</span>
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-7 col-sm-7">
                            <div className="footer__vnt__right">
                                <div className="title">
                                    Đâu là <span className="orange">điểm đến</span> tiếp theo cho chuyến du lịch của bạn
                                </div>
                                <p>Du lịch chưa bao giờ dễ dàng hơn thế cùng VNTRIP</p>
                                <div className="footer__form flexGroup1">
                                    <Form.Item
                                        validateStatus={validateEmail.status}
                                        help={validateEmail.text}
                                        className="mb0"
                                    >
                                        <Input
                                            onChange={(event) => handleChangeEmail(event.target.value)}
                                            size="large"
                                            placeholder="Email của bạn"
                                            value={email}
                                        />
                                    </Form.Item>

                                    <Button loading={isLoading} onClick={handleSubmit} size="large" type="primary" className="btn__orange">
                                        Đăng ký
                                    </Button>
                                </div>
                                <div className="footer__bocongthuong d-flex">
                                    <a href="http://online.gov.vn/Home/WebDetails/65609">
                                        <img
                                            src="https://statics.vntrip.vn/images/logo_bocongthuong_blue.png"
                                            alt="bo cong thuong"
                                        />
                                    </a>
                                    <a href="http://online.gov.vn/Home/WebDetails/24227">
                                        <img
                                            src="https://statics.vntrip.vn/images/logo_bocongthuong_red.png"
                                            alt="bo cong thuong"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer__bottom">
                <div className="container">
                    <p>
                        © Copyright {moment().year()} – {COMPANY_NAME}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Footer
